const UI_ICON_PATHS: Record<string, string> = {
  pass: 'M8 5v14M16 5v14',
  flower:
    'M12 4c1.2 2.2 1.4 3.9.5 5.2-1.1 1.3-3.2 1.2-5-.1C6.1 7.3 7.9 5.6 12 4Zm-6 5c2.4-.1 4 .3 4.9 1.6.8 1.2.6 3.1-.6 4.7C8 17.6 5.9 17.8 4.5 16.8 3.1 15.8 3.2 12.9 6 9Zm12 0c2.8 3.9 2.9 6.8 1.5 7.8-1.4 1-3.5.8-5.8-1.5-1.2-1.6-1.4-3.5-.6-4.7.9-1.3 2.5-1.7 4.9-1.6ZM12 13c1.8 1.7 2.9 3.1 2.9 4.8 0 1.8-1.3 3.2-2.9 3.2s-2.9-1.4-2.9-3.2c0-1.7 1.1-3.1 2.9-4.8Z',
  pollinate: 'M6 8c1.7-1.6 4.4-1.5 6 .2l4 4c1.6 1.7 1.5 4.4-.2 6-1.7 1.6-4.4 1.5-6-.2l-4-4C4.2 12.3 4.3 9.6 6 8Zm9.5-4.5 2 2M18 3l3 3M3 18l3 3M5.5 15.5l2 2',
  donate: 'M12 3l2.8 5.7L21 9.6l-4.5 4.3 1.1 6.1L12 17l-5.6 3 1.1-6.1L3 9.6l6.2-.9L12 3Z',
  evolution: 'M12 3c4.4 0 8 2.7 8 6 0 4.7-4 8.4-8 12-4-3.6-8-7.3-8-12 0-3.3 3.6-6 8-6Zm0 3c-2.4 0-4.2 1.3-4.2 3 0 2.6 2.4 5.1 4.2 6.8 1.8-1.7 4.2-4.2 4.2-6.8 0-1.7-1.8-3-4.2-3Z',
  menu: 'M4 7h16M4 12h16M4 17h16',
  speaker: 'M5 10h4l5-4v12l-5-4H5z M18 9c1.2 1 2 2.5 2 4s-.8 3-2 4',
  music: 'M15 5v10.5a2.5 2.5 0 1 1-2-2.45V7l7-1.5v8a2.5 2.5 0 1 1-2-2.45V5z',
  flowers_small:
    'M12 4c1.6 2 1.9 3.4 1.2 4.6-.8 1.3-2.5 1.7-4.7 1 0-2.7 1-4.4 3.5-5.6Zm4.8 5.2c1.9.2 3.2 1 3.2 2.4 0 1.8-1.8 3.3-4.1 3.3-1.4 0-2.5-.4-3.2-1.3.8-2 2-3.5 4.1-4.4ZM8.1 14.9C5.8 14.9 4 13.4 4 11.6c0-1.4 1.3-2.2 3.2-2.4 2.1.9 3.3 2.4 4.1 4.4-.7.9-1.8 1.3-3.2 1.3Zm3.9.8c1.2 1.2 1.9 2.2 1.9 3.3 0 1.2-.9 2-1.9 2s-1.9-.8-1.9-2c0-1.1.7-2.1 1.9-3.3Z',
}

interface UiIconProps {
  name: keyof typeof UI_ICON_PATHS
  className?: string
  title?: string
}

export function UiIcon({ name, className, title }: UiIconProps) {
  const svg = [
    "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'",
    "stroke='currentColor' stroke-width='1.9' stroke-linecap='round' stroke-linejoin='round'>",
    `<path d='${UI_ICON_PATHS[name]}'/></svg>`,
  ].join(' ')

  return (
    <img
      src={`data:image/svg+xml;utf8,${encodeURIComponent(svg)}`}
      alt=""
      title={title}
      className={className ? `${className} icon` : 'icon'}
    />
  )
}
